// Export Workflow — scoped-review caveat block (scope-selection plan Slice 5), shared by the live
// summary card and Saved Work. Informational (blue `jd-badge--multi` recipe) rather than the amber
// not-assessed one: nothing failed — the user narrowed the run — but it must still be unmissable
// that the checks listed as not requested were not run. Self-hides on a full review.
import React from 'react';

import { ExportAssessmentData } from '../../utils/exportAssessment';
import { SCOPED_REVIEW_NOTICE, scopedReviewSummary } from '../../utils/scopedReviewCaveat';

const infoIcon = (
  <svg width='14' height='14' viewBox='0 0 16 16' fill='none' aria-hidden='true'>
    <circle cx='8' cy='8' r='6.5' stroke='currentColor' strokeWidth='1.4' />
    <path d='M8 7.25V11M8 5v.01' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' />
  </svg>
);

const ScopedReviewSummary: React.FC<{
  data?: ExportAssessmentData;
  variant?: 'full' | 'pill';
}> = ({ data, variant = 'full' }) => {
  const summary = scopedReviewSummary(data);
  if (!summary) return null;

  const pill = (
    <span className='jd-badge jd-badge--multi'>
      {infoIcon}
      <span>{summary.pill}</span>
    </span>
  );
  if (variant === 'pill') return pill;

  return (
    <div className='jd-disposition'>
      {pill}
      <ul className='jd-reasons'>
        <li>In this review: {summary.inReviewLabels.join(', ')}.</li>
        <li>Not requested (not run): {summary.notRequestedLabels.join(', ')}.</li>
      </ul>
      <p className='scoped-review-notice' role='note'>
        {SCOPED_REVIEW_NOTICE}
      </p>
    </div>
  );
};

export default ScopedReviewSummary;
